import { FlightInformationController } from './flight-information-controller';
import { FlightsSearchController } from './flights-search-controller';
import { FlightServicingController } from './flight-servicing-controller';
import { FlightServicingConfirmationController } from './flight-servicing-confirmation-controller';
import { FlightInformationMetaController } from './flight-information-meta-controller';
import { FlightServicingAgentController } from './flight-servicing-agent-controller';
import { FlightsMerchandisingController } from './flights-merchandising-controller';
import { FlightsMerchandisingCheckoutController } from './flights-merchandising-checkout-controller';
import { FlightsMerchandisingConfirmationController } from 'controllers/flights-merchandising-confirmation-controller';

export const controllers = [
  FlightInformationController,
  FlightsSearchController,
  FlightServicingController,
  FlightServicingConfirmationController,
  FlightInformationMetaController,
  FlightServicingAgentController,
  FlightsMerchandisingController,
  FlightsMerchandisingCheckoutController,
  FlightsMerchandisingConfirmationController
];
